import React from 'react'

import { Offcanvas } from 'bootstrap'
import { Outlet, useLocation } from 'react-router-dom'

import AdminHeaderBar from '../../../Layout/AdminHeaderBar/AdminHeaderBar'
import AdminSidebar, { type AdminSidebarActiveKey } from '../../../Layout/AdminSidebar/AdminSidebar'
import './AdminWrapper.scss'

const AdminWrapper: React.FC = () => {
  const location = useLocation()

  const { title, activeKey } = (() => {
    const path = location.pathname.replace(/^\/blockchain/, '')
    if (path.startsWith('/kyc-queue')) return { title: 'Legal', activeKey: 'kyc-queue' as const }
    if (path.startsWith('/investors'))
      return { title: 'Investors', activeKey: 'investors' as const }
    if (path.startsWith('/traders-card'))
      return { title: 'TradersCard', activeKey: 'traders-card' as const }
    if (path.startsWith('/pool-state'))
      return { title: 'Pool State', activeKey: 'pool-state' as const }
    if (path.startsWith('/token-assets'))
      return { title: 'Token Assets', activeKey: 'token-assets' as const }
    if (path.startsWith('/lease-assets'))
      return { title: 'Lease Assets', activeKey: 'lease-assets' as const }
    if (path.startsWith('/notifications'))
      return { title: 'Notifications', activeKey: 'notifications' as const }
    return { title: 'Dashboard', activeKey: 'dashboard' as const }
  })()

  const closeSidebar = () => {
    const el = document.getElementById('adminSidebarOffcanvas')
    if (!el) return
    const instance = Offcanvas.getInstance(el) ?? new Offcanvas(el)
    instance.hide()
  }

  return (
    <div className='admin-shell blockchain-admin-shell'>
      <aside className='admin-shell__sidebar d-none d-lg-block'>
        <AdminSidebar activeKey={activeKey as AdminSidebarActiveKey} />
      </aside>

      <div className='admin-shell__main'>
        <AdminHeaderBar title={title} />
        <main className='admin-shell__content'>
          <Outlet />
        </main>
      </div>

      <div
        className='offcanvas offcanvas-start admin-shell__offcanvas'
        tabIndex={-1}
        id='adminSidebarOffcanvas'
        aria-labelledby='adminSidebarOffcanvasLabel'
      >
        <div className='admin-shell__offcanvas-body'>
          <AdminSidebar
            activeKey={activeKey as AdminSidebarActiveKey}
            variant='offcanvas'
            onNavigate={closeSidebar}
          />
        </div>
      </div>
    </div>
  )
}

export default AdminWrapper
